import { Button, Typography } from "@suraasa/placebo-ui"
import { useGlobalContext } from "global/Context/context"
import { Link } from "react-router-dom"
import routes, { routeBuilder } from "routes"
import { formatDate } from "utils/helpers"

import CpatDisqualifiedImage from "./assets/attempt-disqualified-banner.webp"

const CpatDisqualifiedBanner = ({
  attemptId,
  date,
}: {
  attemptId: number
  date?: string
}) => {
  const { authInfo } = useGlobalContext()

  return (
    <div className="mb-8 flex flex-col rounded-2xl bg-critical-700 md:flex-row md:justify-between">
      <div className="flex flex-row">
        <img
          src={CpatDisqualifiedImage}
          alt="Attempt Disqualified"
          className="hidden h-full w-12 shrink-0 rounded-l-2xl md:block"
        />
        <div className="flex flex-col py-3 pl-3 pr-1 md:pl-0">
          <div className="mb-1 flex flex-row items-center">
            <Typography
              variant={"smallBody"}
              className="text-[12px] text-critical-300"
            >
              ASSESSMENT
            </Typography>
            {date && (
              <>
                <div className="mx-1 size-0.5 rounded-full bg-critical-300" />
                <Typography
                  variant={"strongSmallBody"}
                  className="text-[12px] text-critical-300"
                >
                  {formatDate(date, "dd MMM yyyy")}
                </Typography>
              </>
            )}
          </div>
          <Typography variant={"title3"} className="mb-1.5 text-white">
            Attempt Disqualified
          </Typography>
          <Typography variant={"smallBody"} className="max-w-2xl text-white">
            Your recent CPAT attempt has been disqualified due to proctoring
            violations detected during the test. You can review the proctoring
            report for details of these violations. For further assistance,
            please reach out to us at{" "}
            <a
              className="font-semibold text-warning-300 hover:underline"
              href={`mailto:care@suraasa.com?subject=Query regarding CPAT Proctoring Report&body=Hi Suraasa Team,%0D%0A%0D%0AI have a query regarding my CPAT Proctoring Report. Please find the details below:%0D%0A%0D%0AAttempt ID: ${attemptId} %0D%0AMy email is: ${encodeURIComponent(
                authInfo?.user?.email ?? ""
              )}%0D%0A%0D%0AThank you!`}
            >
              care@suraasa.com
            </a>
          </Typography>
        </div>
      </div>
      <Link
        to={routeBuilder(routes.cpat.proctoringReport, {
          attemptId: attemptId.toString(),
        })}
        className="m-3 shrink-0 md:ml-0 md:self-center"
      >
        <Button className="bg-white text-black" variant={"filled"} size={"sm"}>
          See Proctoring Report
        </Button>
      </Link>
    </div>
  )
}

export default CpatDisqualifiedBanner
